import { format } from 'date-fns';

export const formatWeekday = (date: Date) => format(date, 'EEEEEE');
